import React, {Component} from 'react';
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'

import { bindActionCreators, compose } from 'redux';
import * as folioActions from '../../actions/folio-actions';

import '../../styles.scss';
import Stories from './Stories';
import Projects from './Projects';
import AdminTabs from "./AdminTabs";
import Tools from "./Tools";

class AdminContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: this.getPath()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.auth.isLoaded && this.props.auth.isEmpty) {
      this.props.actions.redirectToLogin();
    }
    if (this.props.location !== prevProps.location) {
      this.setState({ activeTab:  this.getPath() })
    }
  }

  getPath = () => {
    const slugs = this.props.location.pathname.split('/');
    return slugs && slugs.length && slugs[slugs.length-1];
  };


  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = (progress) => this.setState({ progress });
  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    console.error(error);
  };
  handleUploadSuccess = (filename, item) => {
    this.setState({ [item]: filename, progress: 100, isUploading: false });
    this.props.firebase.storage().ref(this.state.form.directory).child(filename).getMetadata().then(data => this.setState({ [item+'Data']: { path: data.fullPath, url: data.downloadURLs[0] } } ));
  };

  selectProject = (e, id) => {
    e.preventDefault();
    this.props.navAdd(id);
  };

  handleDeleteProject = (e, project) => {
    e.preventDefault();
    this.props.firebase.ref('projects').child(project.id).remove().then(() => {
      this.props.actions.showNotification('Project deleted.');
      setTimeout(() => { this.props.actions.hideNotification(); }, 8000);
    });
  };

  handleDeleteStory = (e, story) => {
    e.preventDefault();
    this.props.firebase.ref('stories').child(story).remove().then(() => {
      this.props.actions.showNotification('Story deleted.');
      setTimeout(() => { this.props.actions.hideNotification(); }, 8000);
    });
  };


  backupData = () => {
    this.props.firebase.database().ref().once('value').then(e => { this.download(e.val()) })
  };

  download = (data) => {
    let file = JSON.stringify(data);
    let blob = new Blob([file], {type: "application/json"});
    let url  = URL.createObjectURL(blob);
    let element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', "data.json");

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };


  render() {
    const folioProjects = this.props.projects ? Object.keys(this.props.projects) : [];
    const sortedProjects = folioProjects.map((project) => {
      // Some projects don't have an id assigned, so use the key name.
      const proj = this.props.projects[project];
      proj.id = project;
      return proj
    }).sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));

    return (
        <div id={ this.props.location } className="form-wrapper">
          <ul className="breadcrumbs">
            <li><Link to="/admin/projects">Admin</Link></li>
          </ul>
          <div className={ classnames(['notification', {'is-active': this.props.folio.notification !== ''}])}>
            { this.props.folio.notification }
          </div>
          <form className="form-add-project" onChange={ this.handleInputs } ref={ref => { this.form = ref }}>
            <AdminTabs activeTab={ this.state.activeTab } />
            <Projects sortedProjects={ sortedProjects } handleDeleteProject={ this.handleDeleteProject } activeTab={ this.state.activeTab }/>
            <Stories activeTab={ this.state.activeTab } stories={ this.props.stories } handleDeleteStory={ this.handleDeleteStory }/>
            <Tools backupData={ this.backupData } activeTab={ this.state.activeTab }/>
          </form>
        </div>
    );
  }
}

AdminContainer.propTypes = {
  folio: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  projects: PropTypes.object,
  stories: PropTypes.array
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch),
    navAdd: (id) => { push('/add/1') } ,
  }
}

export default withRouter(compose(
    firebaseConnect(['/projects', '/stories']),
    connect(
        (state) => ({
          folio: state.folio,
          projects: state.firebase.data.projects,
          stories: state.firebase.data.stories,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(AdminContainer))



// WEBPACK FOOTER //
// ./src/containers/admin/admin.js